import React from 'react';

const ErrorState = ({ title = 'Error', error, onRetry }) => (
  <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-8">
    <div className="text-center">
      <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg
          className="w-8 h-8 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-.667-1.732-.001-1.732 1.001v10.002z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-baijamjuree font-bold text-black mb-2">
        {title}
      </h3>
      <p className="text-gray-700 font-baijamjuree mb-6">{error}</p>
    </div>
  </div>
);

export default ErrorState;
